import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { Footer, Header } from '../Common';
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
import AffiliatorLinks from '../../Models/AffiliatorLinks';
class ReferralLink extends React.Component {
    constructor(props) {
        super(props);
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            _id: false,
            link: '',
            user: logged_user
        }
    };
    componentWillMount() {
        AffiliatorLinks.getRefLink(27).then(res => {
            if (res.data.link != null) {
                this.setState({ link: res.data.link })
            }
        })
    }
    render() {
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4 input_name">
                                    <AffiliatorSidebar />
                                </div>
                                <div className="col-md-8">
                                    <div className="mt-5 mb-3 input_name big_font guide_text">
                                        {this.props.t('1')}
                                    </div>
                                    {/* <div className="mail_box">
                                        <div className="col-md-12 tr_blank_medium mt-2 pt-2"></div>
                                        <input type="text" className="mail_box_input" placeholder=" <a href={this.state.link} > 1{this.props.t('0')} </a > " />
                                        <span>{this.state.link}</span>
                                    </div> */}
                                    <div style={{ border: "1px solid", textAlign: "center", verticalAlign: "middle", minHeight: "50px" }}>
                                        <span><b>{this.state.link}</b></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export { ReferralLink }

 ReferralLink = withTranslation('src_Components_Affiliator_ReferralLink')(ReferralLink);